export default "__VITE_ASSET__CpeXtEjo__"